import {
  Box,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect, useState, type FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { UploadFile } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import moment from 'moment';
import SimpleSnackbar from 'src/pages/details-page/sub-components/snackBar';
import {
  getValidationCSVTemplateOfMdsReset,
  uploadCSVTemplateOfMds,
  uploadCSVTemplateOfMdsReset,
} from 'src/redux/actions/therapyPlanning';
import LoaderIcon from '../../../../src/components/LoaderImg/loader.gif';

interface PatientUploadTableProps {
  items?: any;
  source: string;
  validateCSVResponse?: any;
}
const MdsAssessmentUploadTable: FC<PatientUploadTableProps> = (props) => {
  const { items = [], source = '', validateCSVResponse = [] } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [patientError, setPatientError] = useState({
    message: '',
    isError: false,
  });
  const validateCsvResponseOfMds = useSelector((state: any) => state.validateMDSAssessmentCsv);
  const uploadMdsResponse = useSelector((state: any) => state.uploadCsvTemplateMdsReducer);

  const handleUpload = () => {
    dispatch(uploadCSVTemplateOfMds(validateCSVResponse));
  };

  useEffect(() => {
    if (!uploadMdsResponse.isUploadSuccess && uploadMdsResponse.response === null) return;
    if (!uploadMdsResponse.isUploadSuccess && uploadMdsResponse.response !== null) {
      setPatientError({
        message: uploadMdsResponse?.response?.message,
        isError: true,
      });
      setTimeout(() => {
        dispatch(uploadCSVTemplateOfMdsReset());
      }, 3000);
      return;
    }
    if (uploadMdsResponse?.isUploadSuccess)
      setPatientError({
        message: 'MDS Assessment is imported Successfully',
        isError: false,
      });
    setTimeout(() => {
      dispatch(getValidationCSVTemplateOfMdsReset());
      dispatch(uploadCSVTemplateOfMdsReset());
      navigate(-1);
    }, 3000);
    return;
  }, [uploadMdsResponse]);

  return (
    <Box sx={{ position: 'relative' }}>
      {source !== 'invalidRecords' && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: 4 }}>
          <LoadingButton
            startIcon={
              <SvgIcon>
                <UploadFile />
              </SvgIcon>
            }
            variant="contained"
            sx={{
              whiteSpace: 'nowrap',
              height: 40,
              width: 150,
              '.MuiLoadingButton-loadingIndicator': {},
            }}
            loadingPosition="start"
            disabled={
              !validateCsvResponseOfMds?.response?.data?.patientMdsSuccessResponseList?.length ||
              uploadMdsResponse?.loading
            }
            loading={uploadMdsResponse?.loading}
            onClick={handleUpload}
          >
            {' '}
            Confirm Import
          </LoadingButton>
        </Box>
      )}

      <Table sx={{ minWidth: 700 }}>
        <TableHead>
          <TableRow>
            {source === 'invalidRecords' ? (
              <>
                <TableCell>Message</TableCell>
                <TableCell>Patient Mrn</TableCell>
                <TableCell>ASSESSMENT TYPE </TableCell>
                <TableCell>ASSESSMENT DATE </TableCell>
              </>
            ) : (
              <>
                <TableCell>ASSESSMENT TYPE </TableCell>
                <TableCell>ASSESSMENT DATE </TableCell>
                <TableCell>MDS PT - OT</TableCell>
                <TableCell>MDS SLP</TableCell>
                <TableCell>MDS Nursing</TableCell>
                <TableCell>MDS NTA</TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={9}>
                <Box
                  textAlign="center"
                  p={3}
                >
                  <Typography
                    color={'text.secondary'}
                    variant="subtitle2"
                  >
                    No Records Found
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : validateCsvResponseOfMds?.loading ? (
            <TableRow>
              <TableCell colSpan={9}>
                <Box
                  textAlign="center"
                  p={3}
                  py={20}
                >
                  <img
                    src={LoaderIcon}
                    alt="loader.."
                  />
                </Box>
              </TableCell>
            </TableRow>
          ) : (
            items?.map((patient: any) => {
              const patientSuccess = patient?.mdsAssessmentEntity
                ? patient?.mdsAssessmentEntity
                : patient?.importTherapistRequestDto;

              return (
                <TableRow key={patientSuccess?.bedAssignment}>
                  {source === 'invalidRecords' ? (
                    <>
                      <TableCell>
                        <Typography
                          variant="body2"
                          color={'red'}
                        >
                          {patient?.message ? patient?.message : '-'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {patientSuccess?.patientMrn ? patientSuccess?.patientMrn : '-'}
                      </TableCell>
                      <TableCell>
                        {patientSuccess?.assessmentType ? patientSuccess?.assessmentType : '-'}
                      </TableCell>
                      <TableCell>
                        {moment(
                          new Date(
                            new Date(patientSuccess?.assessmentDate)?.valueOf() +
                              new Date(patientSuccess?.assessmentDate)?.getTimezoneOffset() *
                                60 *
                                1000
                          )
                        ).format('DD MMM, YYYY')
                          ? moment(
                              new Date(
                                new Date(patientSuccess?.assessmentDate)?.valueOf() +
                                  new Date(patientSuccess?.assessmentDate)?.getTimezoneOffset() *
                                    60 *
                                    1000
                              )
                            ).format('DD MMM, YYYY')
                          : '-'}
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell>
                        {patientSuccess?.assessmentType ? patientSuccess?.assessmentType : '-'}
                      </TableCell>
                      <TableCell>
                        {moment(
                          new Date(
                            new Date(patientSuccess?.assessmentDate)?.valueOf() +
                              new Date(patientSuccess?.assessmentDate)?.getTimezoneOffset() *
                                60 *
                                1000
                          )
                        ).format('DD MMM, YYYY')
                          ? moment(
                              new Date(
                                new Date(patientSuccess?.assessmentDate)?.valueOf() +
                                  new Date(patientSuccess?.assessmentDate)?.getTimezoneOffset() *
                                    60 *
                                    1000
                              )
                            ).format('DD MMM, YYYY')
                          : '-'}
                      </TableCell>
                      <TableCell>
                        {patientSuccess?.mdsPtOtGroup ? patientSuccess?.mdsPtOtGroup : '-'}
                      </TableCell>
                      <TableCell>
                        {patientSuccess?.mdsSlpGroup ? patientSuccess?.mdsSlpGroup : '-'}
                      </TableCell>
                      <TableCell>
                        {patientSuccess?.mdsNursingGroup ? patientSuccess?.mdsNursingGroup : '-'}
                      </TableCell>
                      <TableCell>
                        {patientSuccess?.mdsNtaGroup ? patientSuccess?.mdsNtaGroup : '-'}
                      </TableCell>
                    </>
                  )}
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>

      {uploadMdsResponse.response !== null && (
        <SimpleSnackbar
          isError={patientError.isError}
          message={patientError.message}
        />
      )}
    </Box>
  );
};

export default MdsAssessmentUploadTable;
